import React from 'react';
import { EExpenseType } from '../enums/expenses/EExpenseType';

interface IProps {
  label: EExpenseType;
  color: {
    background: string;
    primary: string;
  };
}
const CustomChip = ({ label, color }: IProps) => {
  return (
    <div
      style={{
        display: 'inline',
        backgroundColor: color.background,
        color: color.primary,
        borderRadius: '4px',
        fontSize: '0.8125rem',
        textAlign: 'center',
        padding: '5px 11px',
      }}
    >
      {label}
    </div>
  );
};

export default CustomChip;
